import { render, staticRenderFns } from "./MostrarNoticia.vue?vue&type=template&id=708c3a88&"
import script from "./MostrarNoticia.vue?vue&type=script&lang=js&"
export * from "./MostrarNoticia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports